const getTopElement = (elem) => {
  const bodyRect = document.body.getBoundingClientRect().top;
  const elementRect = elem.getBoundingClientRect().top;
  const elementPosition = elementRect - bodyRect;
  return elementPosition;
};

export default getTopElement;
